import { render } from "./DatasetSegmentsFormICCS.vue?vue&type=template&id=dc974c7c"
import script from "./DatasetSegmentsFormICCS.vue?vue&type=script&lang=js"
export * from "./DatasetSegmentsFormICCS.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__